/*
    Please take a look at the contribution guide for i18n, located in [es.js] (currently only in spanish)
*/
export default {
    "general.hello-world": "Hello world"
}